import { Container } from '@mui/material';
import { jsx } from 'react/jsx-runtime';

// src/til/post-detail-page/container.tsx
var PostDetailPageContainer = (props) => {
  return /* @__PURE__ */ jsx(Container, { maxWidth: "md", children: props.children });
};

export { PostDetailPageContainer };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4IL6H7FT.mjs.map